import title from './elements/title';
import titleWithLine from './elements/title-with-line';
import eyebrow from './elements/eyebrow';
import fadeIn from './elements/fade-in';
import fadeInUp from './elements/fade-in-up';
import fadeInUpText from './elements/fade-in-up_text';
import fadeInDown from './elements/fade-in-down';
import fadeInRight from './elements/fade-in-right';
import fadeInLeft from './elements/fade-in-left';
import linkWithIcon from './elements/link-with-icon';

export default [
  title,
  titleWithLine,
  eyebrow,
  fadeIn,
  fadeInUp,
  fadeInUpText,
  fadeInDown,
  fadeInRight,
  fadeInLeft,
  linkWithIcon,
];



// WEBPACK FOOTER //
// ./scripts/animation/animated-elements.js